import { useEffect } from "react";

import axios from "axios";
import { getCookie } from "../../utils/cookieHandler";
import { config } from "../../utils/config";
import { findDataInFields } from "../../utils/helperFuctions";
import SearchableDropdown from "../../components/DynamicList/SearchableDropdown";
import { useState } from "react";

const TemporaryRta = ({ id, callPopUp, fields }) => {
  const branch = findDataInFields(fields, "location.branch");
  const [captainsOptions, setCaptainsOptions] = useState([]);
  const [selectedCaptain, setSelectedCaptain] = useState(null);
  const [isLoadingOptions, setIsLoadingOptions] = useState(false);
  const [isContractGenerating, setIsContractGenerating] = useState(false);

  useEffect(() => {
    if (branch.code !== "AE") return;
    setIsLoadingOptions(true);
    axios
      .get(
        `${config.apiUrl}/api/users/reservationcaptains?branch=2&pagination=false`,
        {
          headers: {
            Authorization: `Bearer ${getCookie("_AT")}`,
          },
        }
      )
      .then((res) => {
        // Map the response to the expected format
        const options = res.data.map((captain) => ({
          value: captain.id,
          label: `${captain.first_name} ${captain.last_name}`,
        }));
        setCaptainsOptions(options);
      })
      .finally(() => setIsLoadingOptions(false));
  }, [branch.code]); // Only runs if branch.code changes

  if (branch.code !== "AE") return null; // Only render for AE

  return (
    <div className="flex flex-col sm:flex-row w-full gap-4 items-end bg-white p-4 rounded-xl">
      <div className="flex-1 flex flex-col sm:flex-row gap-4 items-end">
        <div className="">
          <label
            htmlFor="captain-select"
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            Captain
          </label>
          <SearchableDropdown
            id="captain-select"
            options={captainsOptions}
            value={selectedCaptain}
            onChange={(e) => setSelectedCaptain(e.value)}
            placeholder="Select Captain"
            isLoading={isLoadingOptions}
          />
        </div>
        <button
          type="button"
          className="bg-primary hover:bg-primary-dark text-white font-semibold px-6 py-2 rounded-md shadow transition-colors disabled:opacity-60"
          onClick={async () => {
            try {
              setIsContractGenerating(true);

              const response = await axios.get(
                `${config.apiUrl}/api/auth/pdf-token`,
                {
                  headers: { Authorization: `Bearer ${getCookie("_AT")}` },
                }
              );
              const tempToken = response.data.token;

              const pdfUrl = `${config.apiUrl}/api/vehicles/temporaryRta/${id}?access_token=${tempToken}&captainId=${selectedCaptain}`;
              const res = await axios.get(pdfUrl, {
                headers: { Authorization: `Bearer ${getCookie("_AT")}` },
              });

              window.open(`${config.apiUrl}/assets/` + res.data.name, "_blank");
            } catch (err) {
              console.error(err);
            } finally {
              setIsContractGenerating(false);
            }
          }}
          disabled={
            isLoadingOptions || !selectedCaptain || isContractGenerating
          }
        >
          {isContractGenerating ? "Generating…" : "Generate Temporary RTA"}
        </button>
      </div>
    </div>
  );
};

export default TemporaryRta;
